export const dropdownBundle = {
  floor: {
    suffix: { ko: "층", en: "F", es: "P" }
  },
  leak: { ko: "누수", en: "Leak", es: "Fuga" },
  overuse: { ko: "과사용", en: "Overuse", es: "Sobreconsumo" }
}
